module.exports = __webpack_public_path__ + "static/media/dark-theme-fuel-drop.14c68a5f.svg";